module.exports = __webpack_public_path__ + "static/media/unluck.f2fb7954.svg";